import React, { useState } from 'react';
import { ArrowRight, CheckCircle2, Search, MessageSquare, Shield } from 'lucide-react';
import { AppShell } from '../components/AppShell';
function IntegrationLogo({
  name,
  color
}: {
  name: string;
  color: string;
}) {
  switch (name) {
    case 'Email / SMTP':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-782">
          <rect width="20" height="16" x="2" y="4" rx="2" data-id="element-783" />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" data-id="element-784" />
        </svg>;
    case 'Salesforce':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-785">
          <path d="M17.5 7.5c-1.1 0-2.1.4-2.9 1.1-.6-1.5-2.1-2.6-3.8-2.6-1.9 0-3.5 1.3-3.9 3-.3-.1-.7-.2-1.1-.2-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h11.7c2.1 0 3.8-1.7 3.8-3.8 0-2.1-1.7-3.8-3.8-3.8z" data-id="element-786" />
        </svg>;
    case 'SAP':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-787">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" data-id="element-788" />
        </svg>;
    case 'Jira':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-789">
          <path d="M11.53 2c0 0-5.24 5.24-5.24 5.24l5.24 5.24 5.24-5.24L11.53 2zM5.24 8.29c0 0-5.24 5.24-5.24 5.24l5.24 5.24 5.24-5.24L5.24 8.29zM17.82 8.29l-5.24 5.24 5.24 5.24 5.24-5.24-5.24-5.24z" data-id="element-790" />
        </svg>;
    case 'Notion':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-791">
          <path d="M4 4v16h16V4H4zm12 13h-2v-7.5l-4.5 7.5H7V7h2v7.5l4.5-7.5h2v10z" data-id="element-792" />
        </svg>;
    case 'HubSpot':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-793">
          <path d="M12 2a3 3 0 0 0-3 3c0 .3.1.6.2.8L6.4 8.6a3 3 0 0 0-2.4-.6l-1.8-1.8A3 3 0 1 0 1 8.5l1.8 1.8c-.2.8-.1 1.6.2 2.4l-2.8 2.8a3 3 0 1 0 1.4 1.4l2.8-2.8c.8.3 1.6.4 2.4.2l1.8 1.8a3 3 0 1 0 2.3-2.3l-1.8-1.8c.3-.8.4-1.6.2-2.4l2.8-2.8a3 3 0 1 0-1.4-1.4L9.9 10.8c-.8-.3-1.6-.4-2.4-.2l-1.8-1.8A3 3 0 0 0 8 6.5l2.8-2.8A3 3 0 0 0 12 2z" data-id="element-794" />
        </svg>;
    case 'Slack':
      return <svg viewBox="0 0 24 24" width="24" height="24" data-id="element-795">
          <path fill="#E01E5A" d="M5.5 14.5a2 2 0 1 1-2-2h2v2z" data-id="element-796" />
          <path fill="#E01E5A" d="M6.5 14.5a2 2 0 1 1 4 0v5a2 2 0 1 1-4 0v-5z" data-id="element-797" />
          <path fill="#36C5F0" d="M9.5 5.5a2 2 0 1 1 2-2v2h-2z" data-id="element-798" />
          <path fill="#36C5F0" d="M9.5 6.5a2 2 0 1 1 0 4h-5a2 2 0 1 1 0-4h5z" data-id="element-799" />
          <path fill="#2EB67D" d="M18.5 9.5a2 2 0 1 1 2 2h-2v-2z" data-id="element-800" />
          <path fill="#2EB67D" d="M17.5 9.5a2 2 0 1 1-4 0v-5a2 2 0 1 1 4 0v5z" data-id="element-801" />
          <path fill="#ECB22E" d="M14.5 18.5a2 2 0 1 1-2 2v-2h2z" data-id="element-802" />
          <path fill="#ECB22E" d="M14.5 17.5a2 2 0 1 1 0-4h5a2 2 0 1 1 0 4h-5z" data-id="element-803" />
        </svg>;
    case 'Microsoft Teams':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-804">
          <path d="M16 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm-8 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm11 9h-6a2 2 0 0 0-2 2v3h10v-3a2 2 0 0 0-2-2zM9 14H4a2 2 0 0 0-2 2v3h9v-3a2 2 0 0 0-2-2z" data-id="element-805" />
        </svg>;
    case 'WhatsApp Business':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-806">
          <path d="M12 2a10 10 0 0 0-8.5 15.3L2 22l4.8-1.5A10 10 0 1 0 12 2zm4.3 13.5c-.2.7-1.2 1.3-1.8 1.4-.5.1-1.2.3-3.5-.7-2.8-1.2-4.6-4.1-4.7-4.3-.2-.2-1.1-1.5-1.1-2.9 0-1.4.7-2.1 1-2.4.3-.3.6-.4.8-.4h.3c.2 0 .5 0 .7.5.3.7.9 2.2 1 2.4.1.2.1.4 0 .6-.1.2-.2.3-.4.5-.2.2-.4.4-.5.6-.2.2 0 .5.3.9.5.8 1.1 1.4 1.8 1.9.5.4.9.5 1.1.4.3-.1.6-.7.8-1 .2-.3.5-.2.7-.1.3.1 1.7.8 2 1 .3.1.4.2.5.4.1.3.1 1.1-.1 1.8z" data-id="element-807" />
        </svg>;
    case 'Google Workspace':
      return <svg viewBox="0 0 24 24" width="24" height="24" data-id="element-808">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-809" />
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-810" />
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-811" />
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-812" />
        </svg>;
    case 'Power BI':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-813">
          <path d="M16 4h4v16h-4V4zm-6 6h4v10h-4V10zM4 14h4v6H4v-6z" data-id="element-814" />
        </svg>;
    case 'Odoo':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-815">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z" data-id="element-816" />
        </svg>;
    case 'Monday.com':
      return <svg viewBox="0 0 24 24" width="24" height="24" data-id="element-817">
          <circle cx="6" cy="12" r="3" fill="#FF3D57" data-id="element-818" />
          <circle cx="12" cy="12" r="3" fill="#FFCB00" data-id="element-819" />
          <circle cx="18" cy="12" r="3" fill="#00CA72" data-id="element-820" />
        </svg>;
    case 'Zapier':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-821">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" data-id="element-822" />
        </svg>;
    case 'Trello':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill={color} data-id="element-823">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 14H7V7h3v10zm5-4h-3V7h3v6z" data-id="element-824" />
        </svg>;
    case 'API REST & Webhooks':
      return <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-825">
          <polyline points="16 18 22 12 16 6" data-id="element-826" />
          <polyline points="8 6 2 12 8 18" data-id="element-827" />
          <line x1="14" y1="4" x2="10" y2="20" data-id="element-828" />
        </svg>;
    default:
      return <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-829">
          <rect width="18" height="18" x="3" y="3" rx="2" data-id="element-830" />
        </svg>;
  }
}
type Category = 'Todas' | 'CRM' | 'ERP' | 'Comunicación' | 'Productividad' | 'Automatización' | 'Analytics' | 'Desarrollo';
interface Integration {
  id: number;
  name: string;
  category: Category;
  description: string;
  status: 'connected' | 'available' | 'premium' | 'coming_soon';
  icon: string;
  color: string;
  isDefault?: boolean;
}
const integrations: Integration[] = [{
  id: 15,
  name: 'Email / SMTP',
  category: 'Comunicación',
  description: 'Notificaciones por email incluidas en todos los planes. Reciba alertas, digests diarios y resúmenes semanales directamente en su casilla. Configure plantillas y listas de distribución.',
  status: 'connected',
  icon: '@',
  color: '#6366F1',
  isDefault: true
}, {
  id: 1,
  name: 'Salesforce',
  category: 'CRM',
  description: 'Sincronice alertas regulatorias con cuentas y oportunidades. Cree tareas automáticas cuando se detecten cambios normativos relevantes para sus clientes.',
  status: 'available',
  icon: 'SF',
  color: '#00A1E0'
}, {
  id: 2,
  name: 'SAP',
  category: 'ERP',
  description: 'Integre normativas de importación/exportación con su cadena de suministro. Actualice automáticamente registros de compliance en SAP S/4HANA.',
  status: 'available',
  icon: 'SAP',
  color: '#0FAAFF'
}, {
  id: 3,
  name: 'Jira',
  category: 'Productividad',
  description: 'Cree tickets automáticos en Jira cuando una alerta requiera acción del equipo regulatorio. Vincule disposiciones a épicas de compliance.',
  status: 'available',
  icon: 'JR',
  color: '#0052CC'
}, {
  id: 4,
  name: 'Notion',
  category: 'Productividad',
  description: 'Mantenga una base de conocimiento regulatorio actualizada. Sincronice alertas y disposiciones como páginas en su workspace de Notion.',
  status: 'available',
  icon: 'N',
  color: '#000000'
}, {
  id: 5,
  name: 'HubSpot',
  category: 'CRM',
  description: 'Asocie alertas regulatorias a contactos y empresas. Dispare workflows cuando se detecten cambios que afecten a sus cuentas.',
  status: 'available',
  icon: 'HS',
  color: '#FF7A59'
}, {
  id: 6,
  name: 'Slack',
  category: 'Comunicación',
  description: 'Reciba notificaciones en tiempo real en canales específicos. Configure resúmenes diarios y alertas urgentes por canal.',
  status: 'available',
  icon: 'SL',
  color: '#4A154B'
}, {
  id: 7,
  name: 'Microsoft Teams',
  category: 'Comunicación',
  description: 'Alertas y resúmenes diarios directamente en sus canales de Teams. Integración con Power Automate para flujos personalizados.',
  status: 'available',
  icon: 'MT',
  color: '#6264A7'
}, {
  id: 8,
  name: 'WhatsApp Business',
  category: 'Comunicación',
  description: 'Envíe alertas críticas por WhatsApp a su equipo. Ideal para notificaciones urgentes que requieran atención inmediata.',
  status: 'available',
  icon: 'WA',
  color: '#25D366'
}, {
  id: 9,
  name: 'Google Workspace',
  category: 'Productividad',
  description: 'Sincronice alertas con Gmail, cree eventos en Calendar para vencimientos regulatorios y almacene documentos en Drive.',
  status: 'available',
  icon: 'GW',
  color: '#4285F4'
}, {
  id: 10,
  name: 'Power BI',
  category: 'Analytics',
  description: 'Visualice métricas de compliance en dashboards interactivos. Analice tendencias regulatorias y volumen de alertas por fuente.',
  status: 'premium',
  icon: 'PBI',
  color: '#F2C811'
}, {
  id: 11,
  name: 'Odoo',
  category: 'ERP',
  description: 'Conecte alertas regulatorias con módulos de compras, inventario y calidad. Popular en empresas farmacéuticas de la región.',
  status: 'available',
  icon: 'OD',
  color: '#714B67'
}, {
  id: 12,
  name: 'Monday.com',
  category: 'Productividad',
  description: 'Gestione el seguimiento de disposiciones como items en tableros. Asigne responsables y fechas de vencimiento automáticamente.',
  status: 'available',
  icon: 'MN',
  color: '#FF3D57'
}, {
  id: 13,
  name: 'Zapier',
  category: 'Automatización',
  description: 'Conecte WiSoft Alerts con +5.000 aplicaciones. Cree automatizaciones sin código para cualquier flujo de trabajo regulatorio.',
  status: 'premium',
  icon: 'ZP',
  color: '#FF4A00'
}, {
  id: 14,
  name: 'Trello',
  category: 'Productividad',
  description: 'Cree tarjetas automáticas en tableros Kanban para dar seguimiento a cada disposición o resolución detectada.',
  status: 'available',
  icon: 'TR',
  color: '#0079BF'
}, {
  id: 16,
  name: 'API REST & Webhooks',
  category: 'Desarrollo',
  description: 'Acceda a endpoints REST y configure webhooks para integraciones a medida. Documentación completa con ejemplos en Python y Node.js.',
  status: 'premium',
  icon: '</>',
  color: '#0F172A'
}];
const categories: Category[] = ['Todas', 'CRM', 'ERP', 'Comunicación', 'Productividad', 'Automatización', 'Analytics', 'Desarrollo'];
export function IntegrationsPage() {
  const [activeCategory, setActiveCategory] = useState<Category>('Todas');
  const [searchQuery, setSearchQuery] = useState('');
  const filtered = integrations.filter(app => {
    const matchesCategory = activeCategory === 'Todas' || app.category === activeCategory;
    const matchesSearch = app.name.toLowerCase().includes(searchQuery.toLowerCase()) || app.description.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  const connectedCount = integrations.filter(i => i.status === 'connected').length;
  return <AppShell data-id="element-831">
      <div className="p-6 lg:p-8 max-w-7xl mx-auto space-y-6" data-id="element-832">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4" data-id="element-833">
          <div className="max-w-2xl" data-id="element-834">
            <h1 className="text-2xl text-navy-950 mb-2" data-id="element-835">
              Marketplace de Conectores
            </h1>
            <p className="text-sm text-navy-600 leading-relaxed" data-id="element-836">
              Conecte WiSoft Alerts con las herramientas que su equipo ya
              utiliza. Automatice flujos de trabajo y lleve la inteligencia
              regulatoria a su CRM, ERP o canal de comunicación.
            </p>
          </div>
          <div className="text-sm text-navy-600 bg-white border border-slate-200 rounded-lg px-4 py-2 whitespace-nowrap shadow-card" data-id="element-837">
            <span className="font-semibold text-emerald-600" data-id="element-838">
              {connectedCount}
            </span>{' '}
            conectores activos
          </div>
        </div>

        {/* Search + Filters */}
        <div className="space-y-4" data-id="element-839">
          <div className="relative max-w-md" data-id="element-840">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-841" />
            <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Buscar conectores..." className="w-full h-10 pl-9 pr-4 rounded-md border border-slate-200 bg-white text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500" data-id="element-842" />
          </div>

          <div className="flex flex-wrap gap-2" data-id="element-843">
            {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all border ${activeCategory === cat ? 'bg-navy-950 text-white border-navy-950' : 'bg-white text-navy-600 border-slate-200 hover:border-navy-950'}`} data-id="element-844">
                {cat}
              </button>)}
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-845">
          {filtered.map(app => <div key={app.id} className={`bg-white rounded-xl border p-5 shadow-card flex flex-col h-full transition-colors group ${app.isDefault ? 'border-brand-200 ring-1 ring-brand-100' : 'border-slate-200 hover:border-brand-300'}`} data-id="element-846">
              <div className="flex items-start justify-between mb-4" data-id="element-847">
                <div className="w-11 h-11 rounded-lg bg-white border border-slate-200 flex items-center justify-center group-hover:scale-105 transition-transform shadow-sm" data-id="element-848">
                  <IntegrationLogo name={app.name} color={app.color} data-id="element-849" />
                </div>
                <div data-id="element-850">
                  {app.isDefault && app.status === 'connected' && <span className="inline-flex items-center gap-1 text-[11px] font-medium text-brand-600 bg-brand-50 px-2 py-1 rounded-md border border-brand-100" data-id="element-851">
                      <Shield size={11} data-id="element-852" /> Incluido en tu plan
                    </span>}
                  {!app.isDefault && app.status === 'connected' && <span className="inline-flex items-center gap-1 text-[11px] font-medium text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md" data-id="element-853">
                      <CheckCircle2 size={11} data-id="element-854" /> Conectado
                    </span>}
                  {app.status === 'premium' && <span className="inline-flex items-center text-[11px] font-medium text-amber-600 bg-amber-50 px-2 py-1 rounded-md" data-id="element-855">
                      Premium
                    </span>}
                  {app.status === 'coming_soon' && <span className="inline-flex items-center text-[11px] font-medium text-slate-400 bg-slate-100 px-2 py-1 rounded-md" data-id="element-856">
                      Próximamente
                    </span>}
                </div>
              </div>

              <div className="mb-1.5 flex items-center gap-2" data-id="element-857">
                <h3 className="text-sm font-semibold text-navy-950" data-id="element-858">
                  {app.name}
                </h3>
                <span className="text-[10px] font-medium text-slate-400 uppercase tracking-wider bg-slate-50 px-1.5 py-0.5 rounded-sm border border-slate-100" data-id="element-859">
                  {app.category}
                </span>
              </div>

              <p className="text-xs text-navy-600 flex-1 mb-5 leading-relaxed" data-id="element-860">
                {app.description}
              </p>

              <button className={`w-full py-2 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-2 ${app.isDefault ? 'bg-brand-50 text-brand-600 border border-brand-200 hover:bg-brand-100' : app.status === 'connected' ? 'bg-slate-50 text-navy-600 border border-slate-200 hover:bg-slate-100' : app.status === 'coming_soon' ? 'bg-slate-50 text-slate-400 border border-slate-200 cursor-not-allowed' : 'bg-white text-brand-600 border border-brand-200 hover:bg-brand-50'}`} disabled={app.status === 'coming_soon'} data-id="element-861">
                {app.isDefault ? 'Configurar Email' : app.status === 'connected' ? 'Configurar' : app.status === 'coming_soon' ? 'Próximamente' : 'Conectar'}
                {app.status === 'available' && <ArrowRight size={14} data-id="element-862" />}
                {app.status === 'premium' && <ArrowRight size={14} data-id="element-863" />}
              </button>
            </div>)}
        </div>

        {/* Suggest Integration */}
        <div className="bg-slate-50 border border-slate-200 rounded-xl p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-864">
          <div className="w-11 h-11 rounded-lg bg-brand-100 flex items-center justify-center shrink-0" data-id="element-865">
            <MessageSquare size={20} className="text-brand-600" data-id="element-866" />
          </div>
          <div className="flex-1" data-id="element-867">
            <h3 className="text-sm font-semibold text-navy-950 mb-1" data-id="element-868">
              ¿No encuentra el conector que necesita?
            </h3>
            <p className="text-xs text-navy-600" data-id="element-869">
              Cuéntenos qué herramienta utiliza y nuestro equipo evaluará la
              integración.
            </p>
          </div>
          <button className="bg-white text-navy-950 border border-slate-200 hover:border-navy-950 text-sm font-medium px-5 py-2 rounded-md transition-colors whitespace-nowrap shadow-sm" data-id="element-870">
            Solicitar Conector
          </button>
        </div>
      </div>
    </AppShell>;
}